import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = 'nominas/reportes-recurrentes';

/**
 * Reportes recurrentes (ficha 190): Descuentos, Incidencias y Liquidaciones aplicados en nómina.
 * @param {'descuentos'|'incidencias'|'liquidaciones'} tipo
 * @param {{ fecha_inicial: string, fecha_final: string, conceptos?: number[],
 *   tipos_de_nomina_empleado?: number[] }} params
 * @returns {Promise<{ periodos: object[], filas: object[] } | null>}
 */
export const getReporteRecurrente = async (tipo, params) => {
  try {
    const response = await API.get(`${baseURI}/${tipo}/`, {
      params: {
        fecha_inicial: params.fecha_inicial,
        fecha_final: params.fecha_final,
        conceptos: (params.conceptos || []).join(',') || undefined,
        tipos_de_nomina_empleado: (params.tipos_de_nomina_empleado || []).join(',') || undefined,
      },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

export default getReporteRecurrente;
